import { ReactComponent as CloseIcon } from "../../../assets/icons/regular/close.svg";
import { useFiltersChip } from "./FiltersChip.hooks";
import { Chip, ChipsContainer } from "./FiltersChip.styles";

export const FiltersChip = () => {
  const { savedFilters, removeFilter } = useFiltersChip();

  if (savedFilters.length === 0) {
    return null;
  }
  
  return (
    <>
      {savedFilters.length > 0 && 
        <ChipsContainer>
          {savedFilters.map((each: any, index: number) => (
            <Chip key={index} onClick={() => removeFilter(each)}>
              <span className="label">
                {each.label}
              </span>
              {each.value}
              <button>
                <CloseIcon />
              </button>
            </Chip>
          ))}
        </ChipsContainer>
      }
    </>
  )
}
